export const COLLECTION_PREFIX = 'collection_';

export const PAGINATION_KEYS = {
  START: '@START',
  COUNT: '@COUNT',
  TOTAL: '@TOTAL_COUNT',
};

const defaultFormatInstance = (data) => ({
  id: data['@id'],
});

export default class ModelFactory {
  constructor(ns, formatInstance) {
    this.$ns = ns;
    this.formatInstance = typeof formatInstance === 'function' ? formatInstance : defaultFormatInstance;
    this.format = this.format.bind(this);
  }

  format(data) {
    if (typeof data !== 'object') {
      throw new Error('cannot parse json from received data: ', data);
    }

    const rootKey = Object.keys(data)[0];
    if (typeof rootKey !== 'string') {
      throw new Error('');
    }

    let { ns } = this;
    if (ns.includes('/')) {
      ns = ns.substr(ns.lastIndexOf('/') + 1);
    }
    let listResponseFormat = rootKey === COLLECTION_PREFIX + ns;
    if (!listResponseFormat && rootKey === COLLECTION_PREFIX + ns.toUpperCase()) {
      // FIX service has returned the root key considering ns as ns.toUpperCase();
      ns = ns.toUpperCase();
      listResponseFormat = true;
    }

    const rootObject = data[rootKey];

    const response = {
      start: listResponseFormat ? rootObject[PAGINATION_KEYS.START] : 0,
      count: listResponseFormat ? rootObject[PAGINATION_KEYS.COUNT] : 1,
      total: listResponseFormat ? rootObject[PAGINATION_KEYS.TOTAL] : 1,
    };

    // response format normalization
    // if is list response format { collection_<ns> : { <ns>: [ <instance object> ]  } }
    // if is fetch response format  { <ns>: { <instance object> } }
    const itemsList = listResponseFormat ? rootObject[ns] : [rootObject];

    response.list = itemsList.map((item) => this.formatInstance(item));

    response.unique = function unique() {
      if (this.total === 1) {
        return this.list[0];
      }
      return null;
    };

    return response;
  }

  get ns() {
    return this.$ns;
  }
}
